<h2 mat-dialog-title>
  {{ "brand.campaign.content.commentDialog.title" | translate }}
  <button class="close-icon" tabindex="-1" [mat-dialog-close]="">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <section class="image-comment">
    <div class="section-title">
      <h2 *ngIf="isShownAsImagesCarousel">
        {{ "brand.campaign.content.commentDialog.commentImages" | translate }}
      </h2>
      <h2 *ngIf="post.isRenderedAsImage">
        {{ "brand.campaign.content.commentDialog.commentImage" | translate }}
      </h2>
      <h2 *ngIf="post.mediaType === ContentType.Video">
        {{ "brand.campaign.content.commentDialog.commentVideo" | translate }}
      </h2>

      <span
        class="resolve-check"
        *ngIf="!post?.isReviewImageCommentResolved && post.reviewImageComment"
        (click)="onResolveComment(CommentType.Image)"
      >
        {{ "brand.campaign.content.commentDialog.markAsResolved" | translate }}
        <img src="/assets/images/icons/ic_resolve-default.svg" alt="resolve" />
      </span>
      <span
        class="resolved-check"
        *ngIf="post?.isReviewImageCommentResolved"
        (click)="onUnResolveComment(CommentType.Image)"
      >
        {{ "brand.campaign.content.commentDialog.resolved" | translate }}
        <img src="/assets/images/icons/ic_resolved-active.svg" alt="resolved" />
      </span>
    </div>

    <div class="content">
      <img *ngIf="post.isRenderedAsImage" [src]="post.image" alt="" />
      <div
        *ngIf="post.mediaType === ContentType.Image360 && post.image"
        class="image-360"
      >
        <app-panoramic-viewer [imageUrl]="post.image" />
      </div>
      <app-carousel-preview
        *ngIf="isShownAsImagesCarousel"
        [itemSizePx]="112"
        [numVisibleItems]="4"
      >
        <div
          carouselItem
          *ngFor="let item of getPostContentList()"
          [image]="'url(' + item.url + ')'"
          [videoUrl]="item.videoUrl"
          [fileType]="item.fileType"
          [file]="item"
          [id]="item.id"
        ></div>
      </app-carousel-preview>
      <video
        *ngIf="post.mediaType === ContentType.Video"
        [src]="post.videoUrl"
        controls
      ></video>
      <mat-form-field class="image-comment">
        <input
          matInput
          [(ngModel)]="post.reviewImageComment"
          [placeholder]="
            'brand.campaign.content.commentDialog.addImageComment' | translate
          "
          type="text"
          [disabled]="
            post?.isReviewImageCommentResolved || post.isReviewApproved
          "
        />
      </mat-form-field>
    </div>
  </section>

  <section>
    <div class="section-title">
      <h2>
        {{ "brand.campaign.content.commentDialog.commentText" | translate }}
      </h2>
      <span
        class="resolve-check"
        *ngIf="!post?.isReviewTextCommentResolved && post.reviewTextComment"
        (click)="onResolveComment(CommentType.Text)"
      >
        {{ "brand.campaign.content.commentDialog.markAsResolved" | translate }}
        <img src="/assets/images/icons/ic_resolve-default.svg" alt="resolved" />
      </span>
      <span
        class="resolved-check"
        *ngIf="post?.isReviewTextCommentResolved"
        (click)="onUnResolveComment(CommentType.Text)"
      >
        {{ "brand.campaign.content.commentDialog.resolved" | translate }}
        <img src="/assets/images/icons/ic_resolved-active.svg" alt="resolved" />
      </span>
    </div>

    <div class="post-text">
      <p *ngIf="post.isFacebookPost || post.isLinkedInPost">
        {{ post.text }}
      </p>

      <ng-container *ngIf="post.isGoogleAd">
        <div class="field-preview">
          <p class="label">{{ "googleAdEditor.headlineOne" | translate }}</p>
          {{ post.headlineOne || "-" }}
        </div>
        <div class="field-preview">
          <p class="label">{{ "googleAdEditor.headlineTwo" | translate }}</p>
          {{ post.headlineTwo || "-" }}
        </div>
        <div class="field-preview">
          <p class="label">{{ "googleAdEditor.headlineThree" | translate }}</p>
          {{ post.headlineThree || "-" }}
        </div>
        <div class="field-preview">
          <p class="label">{{ "googleAdEditor.headlineFour" | translate }}</p>
          {{ post.headlineFour || "-" }}
        </div>
        <div class="field-preview">
          <p class="label">{{ "googleAdEditor.headlineFive" | translate }}</p>
          {{ post.headlineFive || "-" }}
        </div>
        <div class="field-preview">
          <p class="label">
            {{ "googleAdEditor.googleAdUploadLongHeadline" | translate }}
          </p>
          {{ post.longHeadline || "-" }}
        </div>
        <div class="field-preview">
          <p class="label">{{ "googleAdEditor.descriptionOne" | translate }}</p>
          {{ post.descriptionOne || "-" }}
        </div>
        <div class="field-preview">
          <p class="label">{{ "googleAdEditor.descriptionTwo" | translate }}</p>
          {{ post.descriptionTwo || "-" }}
        </div>
        <div class="field-preview">
          <p class="label">
            {{ "googleAdEditor.descriptionThree" | translate }}
          </p>
          {{ post.descriptionThree || "-" }}
        </div>
        <div class="field-preview">
          <p class="label">
            {{ "googleAdEditor.descriptionFour" | translate }}
          </p>
          {{ post.descriptionFour || "-" }}
        </div>
        <div class="field-preview">
          <p class="label">
            {{ "googleAdEditor.descriptionFive" | translate }}
          </p>
          {{ post.descriptionFive || "-" }}
        </div>
      </ng-container>
    </div>

    <mat-form-field>
      <mat-label>{{
        "brand.campaign.content.commentDialog.addTextComment" | translate
      }}</mat-label>
      <input
        matInput
        [(ngModel)]="post.reviewTextComment"
        type="text"
        [disabled]="post?.isReviewTextCommentResolved || post.isReviewApproved"
      />
    </mat-form-field>
  </section>
</mat-dialog-content>

<mat-dialog-actions *ngIf="!post.isReviewApproved">
  <button
    class="btn btn--content-only btn--delete"
    tabindex="-1"
    (click)="onDeleteCommentsConfirm()"
    [disabled]="saving || deleting"
    *ngIf="showDeleteButton"
  >
    {{ (deleting ? "shared.deleting" : "shared.delete") | translate }}
  </button>
  <div>
    <button class="btn btn--white" tabindex="-1" [mat-dialog-close]="">
      {{ "shared.cancel" | translate }}
    </button>
    <button
      class="btn btn--primary"
      tabindex="-1"
      (click)="onSave()"
      [disabled]="isSaveDisabled()"
    >
      {{ (saving ? "shared.saving" : "shared.save") | translate }}
    </button>
  </div>
</mat-dialog-actions>
<app-autosave-tooltip [running]="autoSaving"></app-autosave-tooltip>
